import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledFilterAppliedBarContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: column;

  @media (min-width: ${Breakpoints.b560}px) {
    align-items: center;
    justify-content: flex-start;
    flex-flow: row;
  }
`;
export const StyledFilterAppliedLabel = styled.div`
  width: fit-content;
  margin-right: 10px;
  display: none;
  @media (min-width: ${Breakpoints.b560}px) {
    display: flex;
  }
`;
export const StyledFilterAppliedBar = styled.div`
  ${({ theme }) => `
  display: flex;
  width: auto;
  max-width: 100%;
  overflow-x: auto;

  & > .slick-carousel {
    width: 100%;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    width: auto;
    max-width: ${theme.size.grid017};
  }

  @media (min-width: ${Breakpoints.b560}px) {
    width: auto;
    max-width: ${theme.size.grid014};
  }
  `}
`;
export const StyledFilterCleanAllButton = styled.div`
  width: 100%;
  padding-top: 15px;
  cursor: pointer;
  @media (min-width: ${Breakpoints.b560}px) {
    width: auto;
    padding-top: 0;
    padding-left: 15px;
  }
`;

export const StyledAppliedFilterItem = styled.div<any>`
  margin-right: 10px;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: #c2cacf;
  color: #3c484d;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 26px;
  width: max-content;
  & > span {
    margin-right: 6px;
  }
  & > svg {
    margin-bottom: 0.11em;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    ${({ isSticky }) => `
      ${
        isSticky
          ? ` margin-right: 0;
              margin-left: 15px;
            `
          : 'margin-right: 15px;'
      }
    `}
`;

export const StyledStickyFilterCleanAllButton = styled.div`
  @media (min-width: ${Breakpoints.b1280}px) {
    margin-left: 15px;
  }
`;

export const StyledFilterItemOnCloseButton = styled.div`
  cursor: pointer;
`;

export const StyledStickyFirstAppliedFilterWrapper = styled.div`
  ${({ theme }) => `
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  @media (min-width: ${Breakpoints.b560}px) {
    display: flex;
  }
  @media (min-width: ${Breakpoints.b1280}px) {
    max-width: ${theme.size.grid008};
  }
  `}
`;

export const StyledStickyAppliedFilterBarContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 15px;
  padding-top: 20px;
  padding-right: 30px;

  @media (min-width: ${Breakpoints.b560}px) {
    padding: 40px 0 40px 0;
    row-gap: 15px;
  }
  @media (min-width: ${Breakpoints.b1280}px) {
    padding: 0;
    padding-left: 60px;
    flex-flow: row;
    gap: 0;
  }
`;

export const StyledStickyAppliedFilterMoreButton = styled.div`
  display: none;
  @media (min-width: ${Breakpoints.b1280}px) {
    margin-left: 15px;
    display: block;
    & > span {
      margin: 0;
      & > a {
        cursor: pointer;
      }
    }
  }
`;

export const StyledClearAllButtonContainer = styled.div`
  & > span {
    margin: 0;
    & > a {
      cursor: pointer;
    }
  }
`;

export const StyledTooltipFilterApplied = styled.div`
  ${({ theme }) => `
    display: flex;
    row-gap: 10px;
    flex-wrap: wrap;
    opacity: 1 !important;
    background: #dfe4e8;
    max-width: ${theme.size.grid004};
  `}
`;
